import React from "react";
import * as c from "./blogPostInternalAd.module.scss";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { ContentfulCta } from "@components/shared/cta";
import classNames from "classnames";

const BlogPostInternalAd = ({ className, heading, subheading, image, ctas = [] }) => {
  // This is modelled as a multi-reference field in Contentful to make it easier to adjust
  // in the future if we end up needing more than one CTA. This way we avoid the need to
  // update the model and deal with migrations. We only need to check the first index since
  // we have a validation rule in the Contentful editor that limits the number of CTAs to 1.
  const cta = ctas && ctas.length > 0 ? ctas[0] : null;

  // We only support CTAs that are "Link" style and have an icon for now
  const mandatoryCtaProps = {
    style: "Link",
    showIcon: true,
    iconVersion: "v2",
  };

  const ctaProps = cta ? { ...cta, ...mandatoryCtaProps } : {};

  return (
    <div className={classNames(c.container, className)}>
      <GatsbyImage
        className={c.image}
        objectFit="cover"
        objectPosition="center center"
        image={getImage(image)}
        alt={heading}
      />
      <div className={c.text}>
        <h3 className={c.heading}>{heading}</h3>
        <p className={c.subheading}>{subheading?.subheading}</p>
        {cta && <ContentfulCta className={c.cta} {...ctaProps} />}
      </div>
    </div>
  );
};

export { BlogPostInternalAd };
